import { TrustSignals, TrustSignalsBadgeContainer } from '@dbt-labs/metadata-shared';
import { CellContext } from '@dbt-labs/sourdough';

type SourceTrustSignalCellProps<TData extends object> = CellContext<
  TData,
  TrustSignals
>;

export const SourceTrustSignalCell = <TData extends object>({
  getValue,
}: SourceTrustSignalCellProps<TData>) => {
  const value = getValue();
  return (
    <TrustSignalsBadgeContainer
      resourceType="source"
      trustSignals={value}
      shouldRenderStateHeader={true}
    />
  );
};
